<template>
    <div>
        <payout-details-list-item v-if="isConversion" :is-payout="isPayout" :payout="payout" />

        <div v-else-if="isPayout">
            <payout-details-list-item
                v-for="item in payout.items"
                :key="payout.id + item.id"
                :is-payout="isPayout"
                :payout="item"
            />
        </div>
    </div>
</template>

<script>
    import PayoutDetailsListItem from './PayoutDetailsListItem.vue';

    export default {
        name: 'PayoutDetailsList',

        components: {
            PayoutDetailsListItem
        },

        props: {
            payout: {
                type: Object,
                default: null
            },
            isPayout: {
                type: Boolean,
                default: false
            },
            isConversion: {
                type: Boolean,
                default: false
            }
        }
    };
</script>
